function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "play-hi-dark_svg__b",
  x1: 321.52,
  y1: -1277.6,
  x2: 321.52,
  y2: -1210.41,
  gradientTransform: "matrix(.56 -.56 .71 .71 825.43 1191.62)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "play-hi-dark_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 16,
  width: 160,
  height: 160,
  rx: 80,
  ry: 80,
  fill: "none"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Apps_ic_hi"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Bill_ic_hi"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Report_ic_hi"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "vodafone_store_ic_hi"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Broadband_ic_hi"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h192v192H0z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 16,
  width: 160,
  height: 160,
  rx: 80,
  ry: 80,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 174a80.23 80.23 0 01-80-79v1a80.24 80.24 0 0080 80 80.24 80.24 0 0080-80v-1a80.23 80.23 0 01-80 79z",
  opacity: 0.06
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#play-hi-dark_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  fill: "url(#play-hi-dark_svg__b)",
  d: "M175.63 129.63l-55.23 55.24-47.51-47.51 65.36-45.11 37.38 37.38z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M135 89.17L86.41 53c-3.13-2.57-6.27-3.18-9.35-1.83A8.69 8.69 0 0072 58.78a2 2 0 000 .22v74a8.47 8.47 0 008 8.53h.24a8.32 8.32 0 005.08-1.73l.86-.64 47.51-35.32 1.36-1a8.18 8.18 0 00-.05-13.67z",
  fill: "#e60000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.07 100.3l-1.36 1-47.51 35.34-.86.64a8.32 8.32 0 01-5.08 1.72H80a8.47 8.47 0 01-8-8.53V133a8.47 8.47 0 008 8.53h.24a8.32 8.32 0 005.08-1.73l.86-.64 47.51-35.32 1.36-1a8.07 8.07 0 003.52-8 8.19 8.19 0 01-3.5 5.46z",
  opacity: 0.12
}))))));

var SvgPlayHiDark = function SvgPlayHiDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Apps_ic",
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2);
};

export default SvgPlayHiDark;